import { render, staticRenderFns } from "./codeInput.vue?vue&type=template&id=32d0f594&scoped=true"
import script from "./codeInput.vue?vue&type=script&lang=ts"
export * from "./codeInput.vue?vue&type=script&lang=ts"
import style0 from "./codeInput.vue?vue&type=style&index=0&id=32d0f594&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d0f594",
  null
  
)

export default component.exports